<template>
  <div>
    <a
      class="sharer__item _item"
      :class="[`-${item}`]"
      v-for="item in list"
      :key="item"
      :data-goal="
        typeof goals === 'string' ? goalFor(item) : goals[item] || void 0
      "
      :data-pixel="pixels[item] || void 0 | randomizeLink"
      :href="linkFor(item)"
      target="_blank"
    >
      <div class="sharer__icon _icon">
        <svg-use :icon="`share-${item}`" />
      </div>
    </a>
  </div>
</template>

<script>
import SharerMixin from "../mixins/SharerMixin";

export default {
  mixins: [SharerMixin],
  data() {
    return {};
  }
};
</script>

<style lang="scss"></style>
